import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const resendOtpKYC = createAsyncThunk(
  "resendOtpKYC/resendOtpKYCUsers",
  async (payload, thunkAPI) => {
    try {
      
      const response = await api.post("KYC-details/resend-otp", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const resendOtpKYCSlice = createSlice({
  name: "resendOtpKYC",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resendOtpKYC.pending, (state) => {
        state.loading = true;
      })
      .addCase(resendOtpKYC.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(resendOtpKYC.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default resendOtpKYCSlice.reducer;
